"use client";

import { useState, useTransition } from "react";
import { useRouter } from "next/navigation";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

interface DailyHistoryLinkProps {
  date: string;
  at: string;
}

export function DailyHistoryLink({ date, at }: DailyHistoryLinkProps) {
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isPending, startTransition] = useTransition();
  const busy = loading || isPending;

  async function openHistory() {
    setLoading(true);
    setError("");
    try {
      const authToken = typeof window !== "undefined"
        ? localStorage.getItem("auth_token")
        : null;
      const headers: Record<string, string> = { "Content-Type": "application/json" };
      if (authToken) headers.Authorization = `Bearer ${authToken}`;

      const response = await fetch("/api/history-token", {
        method: "POST",
        headers,
        body: JSON.stringify({ date, at }),
      });
      if (response.status === 401) {
        setError("登录后可查看交互热搜榜，或在首页选择日期完成验证。");
        return;
      }
      if (!response.ok) {
        setError("暂时无法打开交互热搜榜，请稍后重试。");
        return;
      }

      const data = await response.json() as { href?: string };
      if (data.href) {
        startTransition(() => router.push(data.href!));
      }
    } catch {
      setError("网络异常，请稍后重试。");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex flex-col items-start gap-2 sm:items-end">
      <Button type="button" onClick={openHistory} disabled={busy}>
        {busy && <Loader2 className="h-4 w-4 animate-spin" />}
        查看交互热搜榜
      </Button>
      {error && <p className="max-w-xs text-xs leading-5 text-amber-700 sm:text-right">{error}</p>}
    </div>
  );
}
